var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useCallback, useState } from 'react';
export var useAccordion = function (isCollapsible, defaultExpanded) {
    if (isCollapsible === void 0) { isCollapsible = true; }
    if (defaultExpanded === void 0) { defaultExpanded = []; }
    var _a = __read(useState(defaultExpanded), 2), expanded = _a[0], setExpanded = _a[1];
    var toggle = useCallback(function (sectionName) {
        if (isCollapsible) {
            setExpanded(expanded.includes(sectionName)
                ? expanded.filter(function (name) { return name !== sectionName; })
                : __spread(expanded, [sectionName]));
        }
    }, [isCollapsible, expanded]);
    var isExpanded = useCallback(function (sectionName) { return !isCollapsible || expanded.includes(sectionName); }, [isCollapsible, expanded]);
    return [toggle, isExpanded];
};
